//Mouse Interactions and Settings
//export const accent = d3.scaleOrdinal().range(['#6A148E']);
import * as d3 from "d3";
import highlighIcon from "./images/plusIcon.svg";
import highlighIconHover from "./images/plusIconHover.svg";

export const customScheme = ["#6A148E"];
export const colorScale = d3.scaleOrdinal(customScheme);

export const tooltip = d3
  .select("#zoopla-bar-chart-horizontal")
  .append("div")
  .attr("class", "tooltipStyle");

const xAxisTickFormat = d3.timeFormat("%d %b");

export const mouseover = function (data, index) {
  d3.select(this)
    .attr("width", "28px")
    .attr("height", "28px")
    .attr("xlink:href", highlighIconHover);

  tooltip
    .style("visibility", "visible")
    .html(
      `<span style="font-size: 12px"><strong>23 March: </strong>Government announces closure of all non-essential businesses, including estate agents.</span>`
    );
};

export const mouseout = function (data, index) {
  d3.select(this)
    .attr("width", "28px")
    .attr("height", "28px")
    .attr("xlink:href", highlighIcon);

  tooltip.style("visibility", "hidden");
};

export const mousemove = function (data, index) {
  tooltip.style("top", event.pageY - 10 + "px").style("left", function () {
    if (event.pageX + 90 > innerWidth) {
      return event.pageX - 44 + "px";
    } else {
      return event.pageX + 18 + "px";
    }
  });
};

//Mouse Interactions and Settings Ends here
